import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workDocsSchemeClassGrid: [],
    workDocsSchemeClassAll: [],
    workDocsSchemeClassShow: null,
    pageData: null,
  },
  mutations: {
    setWorkDocsSchemeClassGrid(state, payload) {
      state.workDocsSchemeClassGrid = payload
    },
    setWorkDocsSchemeClassAll(state, payload) {
      state.workDocsSchemeClassAll = payload
    },
    setWorkDocsSchemeClassShow(state, payload) {
      state.workDocsSchemeClassShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workDocsSchemeClassGrid: (state) => {
      return state.workDocsSchemeClassGrid
    },
    workDocsSchemeClassAll: (state) => {
      return state.workDocsSchemeClassAll
    },
    workDocsSchemeClassShow: (state) => {
      return state.workDocsSchemeClassShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkDocsSchemeClassGrid({ commit, rootState }, { limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain + '/api/admin/work/scheme-class/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsSchemeClassGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkDocsSchemeClassAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain + '/api/admin/work/scheme-class/grid?limit=0' + '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsSchemeClassAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsSchemeClassShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/scheme-class/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsSchemeClassShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsSchemeClassCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/scheme-class',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsSchemeClassUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/scheme-class',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsSchemeClassDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/scheme-class/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
